import styled, { css } from "styled-components";

export const Wrapper = styled.div`
width: 100%;
padding-right: 30px;

`
export const Header = styled.div`
width: 100%;
margin-bottom: 15px;
`
export const ClassInfo = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
`
export const Title = styled.h1`
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 32px;
color: #2555EF;
text-transform: capitalize;
img{
    cursor: pointer;
    margin-right: 17.53px;

}
`
export const ButtonGroup = styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
width: 407px;
height: 36px;

`
export const ShareClass = styled.button`
display: flex;
align-items: center;
width: 110px;
height: 26px;
color: #2555EF;
font-weight: bold;

font-size: 12px;
line-height: 26px;
background-color: transparent;
border: none;
img{padding-right: 7.5px;
}
`
export const EditClass = styled.button`
display: flex;
align-items: center;
justify-content: center;

padding: 2px 11px;
gap: 8px;
width: 115px;
height: 36px;
color: #2555EF;
font-weight: bold;
font-size: 12px;
line-height: 26px;
background: rgba(37, 85, 239, 0.08);
border-radius: 4px;
img{padding-right: 7.5px;
}
`
export const AddParticipant = styled.button`
display: flex;
align-items: center;
justify-content: center;
color: #FFFFFF;
background-color: #2555EF;
font-weight: 500;
font-size: 13px;
line-height: 32px;
width: 165px;
height: 36px;
border-radius: 4px;
padding: 2px 11px;
gap: 8px;
font-weight: bold;
img{padding-right: 7.5px;
}

`
export const FilterWrapper = styled.div`
display: flex;
align-items: center;
width: 230px;
margin-top: 25px;
`
export const Filter = styled.button`
display: flex;
justify-content: center;
align-items: center;
padding: 12px 10px;
gap: 10px;
width: 79px;
height: 45px;
background-color: #FFFFFF;
border: none;
color:#404253;
font-size: 13px;
border-radius: 4px;
margin-right: 14px;
${(props) => (props.isFilterOpen &&
        css`
        color: #FFFFFF;
        background: #2555EF;

      `

    )}
`
